import { render } from "./ThemesSelector.vue?vue&type=template&id=1d74dff4&scoped=true"
import script from "./ThemesSelector.vue?vue&type=script&lang=js"
export * from "./ThemesSelector.vue?vue&type=script&lang=js"

import "./ThemesSelector.vue?vue&type=style&index=0&id=1d74dff4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d74dff4"]])

export default __exports__